import React, {useEffect, useRef, useState} from "react";
import styles from "./SecondaryCollapsibleSection.module.css";
import {Arrow} from "../../arrow/Arrow";
import classnames from "classnames";

interface SectionProps {
    title: string;
    disabled?: boolean;
    collapsedByDefault?: boolean;
    children: React.ReactNode;
}

export const SecondaryCollapsibleSection: React.FC<SectionProps> = ({
                                                                        title,
                                                                        disabled,
                                                                        collapsedByDefault = false,
                                                                        children
                                                                    }) => {

    const [isOpen, setIsOpen] = useState<boolean>(!disabled && !collapsedByDefault)
    const contentRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (disabled) {
            setIsOpen(false)
        } else if (!collapsedByDefault) {
            if (!isOpen) {
                setIsOpen(true)
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [disabled]);

    return <div className={classnames(styles.wrapper, disabled && styles.wrapperDisabled)}>
        <div className={styles.titleWrapper} onClick={event => event.stopPropagation()}>
            <Arrow isUp={isOpen} disabled={disabled} onClick={setIsOpen}/>
            <span className={classnames(styles.title, disabled && styles.titleDisabled)}>{title}</span>
        </div>
        <div
            className={`${styles.childrenWrapper} ${isOpen ? styles.open : ""}`}
            ref={contentRef}
            style={{maxHeight: isOpen ? `${contentRef.current?.scrollHeight}px` : "0"}}>
            {children}
        </div>
    </div>
}
